import listActions from 'src/modules/following/list/followingListActions';
import FollowingService from 'src/modules/following/followingService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import { getHistory } from 'src/modules/store';
import Message from 'src/view/shared/message';

const prefix = 'FOLLOWING_DESTROY';

const followingDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: (id) => async (dispatch) => {
    try {
      dispatch({
        type: followingDestroyActions.DESTROY_STARTED,
      });

      await FollowingService.destroyAll([id]);

      dispatch({
        type: followingDestroyActions.DESTROY_SUCCESS,
      });

      Message.success(
        i18n('entities.following.destroy.success'),
      );

      dispatch(listActions.doFetchCurrentFilter());

      getHistory().push('/following');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: followingDestroyActions.DESTROY_ERROR,
      });
    }
  },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: followingDestroyActions.DESTROY_ALL_STARTED,
      });

      await FollowingService.destroyAll(ids);

      dispatch({
        type: followingDestroyActions.DESTROY_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doChangeSelected([]));
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(
        i18n('entities.following.destroyAll.success'),
      );

      getHistory().push('/following');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: followingDestroyActions.DESTROY_ALL_ERROR,
      });
    }
  },
};

export default followingDestroyActions;
